import React, { Suspense, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { useLocation } from 'react-router-dom';
import { Box, Dialog, DialogTitle, IconButton } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import useModal from 'hooks/useModal';
import modal from 'recoil/atoms/modal';


const AutoModals = () => {
    const modals = useRecoilValue(modal);
    const { hideModal, _hideLastModal, _clearModals } = useModal();
    const { t } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        if (!modals.length) return;

        if (!location.state?.modal) { // moved back or fourth when no modal should be open
            _clearModals();
            return;
        }

        const modalIdx = modals.findIndex(m => m.modalProps.id === location.state?.modal);
        if (modalIdx > -1 && modalIdx < modals.length - 1) // not last modal, but still opened
            _hideLastModal();

        // eslint-disable-next-line
    }, [location]);

    return <>
        {modals.map(m => {
            const { title, action, id, fullScreen, ...props } = m.modalProps;
            const ModalContent = m.component;

            const realFullScreen = isMobile && fullScreen !== false ? true: fullScreen;

            return (
                <Dialog
                    key={id}
                    open={id === location.state?.modal}
                    keepMounted
                    disableRestoreFocus // TODO wait https://github.com/mui/material-ui/issues/33004
                    onClose={hideModal}
                    fullScreen={realFullScreen}
                    {...props}
                >
                    {title && (
                        <DialogTitle>
                            {isMobile && (
                                <IconButton
                                    aria-label="back"
                                    onClick={hideModal}
                                >
                                    <ChevronLeft color="action"/>
                                </IconButton>
                            )}
                            {' '}
                            {title}

                            {action && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                    }}
                                >
                                    {action}
                                </Box>
                            )}
                        </DialogTitle>
                    )}

                    <Suspense fallback={<Box sx={{p:2, textAlign: 'center'}}>{t('Loading...')}</Box>}>
                        <ModalContent
                            {...m.props}
                            onFinish={m.promise.resolve}
                            onCancel={m.promise.reject}
                        />
                    </Suspense>
                </Dialog>
            )
        })}
    </>;
};

export default AutoModals;
